<template>
  <div>
    <mdb-card class="mb-4" v-if="error">
      <mdb-card-header>Links</mdb-card-header>
      <mdb-card-body>
        <error :error="error"/>
      </mdb-card-body>
    </mdb-card>
    <mdb-card class="mb-4" v-if="linksData">
      <mdb-card-header>{{linksData.title}}</mdb-card-header>
      <mdb-card-body>
        <mdb-list-group>
          <mdb-list-group-item v-bind:key="link.id"
                               v-for="link in linksData.links">
            <div v-if="!link.url">{{link.title}} <mdb-badge color="warning">Link is Missing</mdb-badge></div>
            <a v-if="link.url && link.url.startsWith('http')" :href="link.url" target="_blank">{{link.title}}
              <mdb-icon v-if="link.url && link.url.startsWith('http')" icon="external-link"/>
            </a>


           <router-link v-if="link.url && !link.url.startsWith('http')" :to="link.url">{{link.title}}</router-link>
          </mdb-list-group-item>
        </mdb-list-group>

      </mdb-card-body>
    </mdb-card>

  </div>
</template>

<script>
import error from '../common/Error'
import {
  mdbBadge,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbListGroup,
  mdbListGroupItem
} from 'mdbvue';

export default {
    name: 'linksSection',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbListGroup,
      mdbListGroupItem,
      mdbIcon,
      mdbBadge,
      error
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      section: {
        type: Object,
        default: null
      }

    },
    data() {
      return {
        linksData: null,
        error: null
      };
    },
    mounted() {
      if (!this.group) {
        return
      }
      this.linksData = this.section.data
      this.linksData.links.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))
    }
  };
</script>
